export const ACTION_ACCEPT_SHARE_TITLE = 'Accept Share';
export const ACTION_DECLINE_SHARE_TITLE = 'Decline Share';
export const ACTION_PREVIEW_LATER_TITLE = 'Preview Later';
export const ACTION_VIEW_QUIZ_SUMMARY = 'View Quiz Summary';
